import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tf-select-display',
  standalone: true,
  template: `<span>{{ value() ?? '—' }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectDisplayComponent {
  readonly value = input<unknown>();
}
